import React from 'react';
import "./modal.css"

const Modal = ({ active, setActive, children, width, height }) => {
    const modalContentStyle = {
        width: width,
        height: height
    };

    return (
        <div>
            <div className={active ? "modal active" : "modal"} onClick={() => setActive(false)}>
                <div className={active ? "modal__content active" : "modal__content"} style={modalContentStyle} onClick={e => e.stopPropagation()}>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Modal;
